import * as commander from 'commander';
import container from "./inversify.config";
import TYPES from "./TYPES";
import { ConsoleUI } from "./utils/ConsoleUI";
import { AliasWorker } from "./entities/Alias";

commander
    .command("list")
    .description("List all the existing Alias")
    .action((cmd, options) => {
        const ui = container.get<ConsoleUI>(TYPES.ConsoleUI);
        const worker = container.get<AliasWorker>(TYPES.AliasWorker);

        worker.list()
       .then(res => {
            ui.loaderSuccess("Ok");
            ui.log(res);
        })
        .catch(err => {
            ui.loaderFail("Error");
            ui.log(err.message);
            process.exit(100);
        });
    });


commander
    .command("create")
    .description("Create a new Alias")
    .action((cmd, options) => {
        const ui = container.get<ConsoleUI>(TYPES.ConsoleUI);
        const worker = container.get<AliasWorker>(TYPES.AliasWorker);

        worker.create()
            .then(res => {
                ui.loaderSuccess("Ok");
                ui.log(res);
            })
            .catch(err => {
                ui.loaderFail("Error");
                ui.log(err.message);
                process.exit(100);
            });
    });

commander
    .command("delete")
    .option('-n, --aliasname <value>', 'alias name')
    .option('-y, --yes', 'automatically confirm')
    .description("Delete an existing Alias")
    .action(function(cmd, options)  {

        const ui = container.get<ConsoleUI>(TYPES.ConsoleUI);
        const worker = container.get<AliasWorker>(TYPES.AliasWorker);

        let func = worker.delete(cmd.aliasname, cmd.yes);


        func.then(res => {
            ui.loaderSuccess("Ok");
        })
        .catch(err => {
            ui.loaderFail("Error");
            ui.log(err.message);
        });

    });

commander
    .command("update")
    .description("Update an existing Alias using a json dotted notation")
    .option('-n, --aliasname <value>', 'aliasname')
    .option('-c, --change <value>', 'The parameter to change in JSON dotted notation ,example: a.b.c="new value"')
    .action((cmd, options) => {

        const ui = container.get<ConsoleUI>(TYPES.ConsoleUI);
        const worker = container.get<AliasWorker>(TYPES.AliasWorker);

        if(!cmd.aliasname) {
            return ui.loaderFail("error: option `-n, --aliasname <value>' argument missing");
        }

        if(!cmd.change) {
            return ui.loaderFail("error: option `-c, --change <value>' argument missing");
        }

        worker.update(cmd.aliasname, cmd.change)
        .then(res => {
            ui.loaderSuccess("Ok");
        })
        .catch(err => {
            ui.loaderFail("Error");
            ui.log(err.message);
        });

    });

commander.parse(process.argv);
if (!commander.args.length) commander.help();